<template>
  <div class="alert-dialog">
    <slot />
  </div>
</template>

<script setup lang="ts">
// Add your component logic here
</script>

<style scoped>
.alert-dialog {
  /* Add your styles here */
}
</style>
